import { ref } from 'vue';
import { tryOnMounted, tryOnUnmounted } from '@vueuse/shared';
import { defaultDocument } from '../utils/component-lib.esm5.js';
function useStyleTag() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    document = defaultDocument
  } = options;
  const styleTag = ref(null);
  function createStyleTag() {
    if (!document) return;
    styleTag.value = document.createElement('style');
    document.head.appendChild(styleTag.value);
  }
  function unload() {
    document.head.removeChild(styleTag.value);
  }
  tryOnMounted(createStyleTag);
  tryOnUnmounted(unload);
  return styleTag;
}
export { useStyleTag };